import { useBehavior, useButton, useTriggerAction } from '@libs/hooks';
import { TTimerButtonData, TWidgetProps } from '@libs/types';
import React, { useMemo } from 'react';
import { TButtonOption } from '../../types/options';
import { ButtonRowView } from './ButtonRowView';
import { useInterval } from './hooks';
import { getSecondsToDate } from './utils/dateUtils';

export const ButtonRowTimer = ({ widget }: TWidgetProps<TTimerButtonData, TButtonOption>) => {
    const data = widget.data ?? {};
    const { isHidden, isDisabled } = useBehavior(widget);
    const { triggerActionsByType, triggerActionsByNameAndType } = useTriggerAction(widget);
    const { handleClick } = useButton(widget, { isDisabled, triggerActionsByType, triggerActionsByNameAndType });

    const totalSeconds = useMemo(() => getSecondsToDate(data.endDate), [data.endDate]);

    const { time, timerEnd } = useInterval(1000, totalSeconds);

    const label = timerEnd ? data.messages?.label : `${data.messages?.timerTitle} ${time}`;

    return (
        <ButtonRowView
            uid={widget.uid}
            isHide={isHidden}
            isDisabled={!timerEnd}
            label={label}
            hierarchy={widget.options?.hierarchy ?? 'primary'}
            iconName={data.iconName}
            onClick={() => handleClick()}
        />
    );
};
